import { Reducer } from 'redux';
import { APIAction, APIActionTypes } from './APIActions';

export interface APIState {
    isLoading: boolean;
}

export const defaultState: APIState = {
    isLoading: true
};

export const apiReducer: Reducer<APIState, APIAction> = (
    state = defaultState,
    action: APIAction
) => {
    switch (action.type) {
        case APIActionTypes.API_LOAD_NEEDED: {
            return {
                ...state,
                isLoading: action.payload.loadNeeded
            };
        }
        default: {
            return state;
        }
    }
};
